<ng-container *ngIf="route">
    <div class="route-stats">


        <!-- NÚMERO DE SHIPMENTS -->
        <div class="block-route-card-info-count shipment" *ngIf="route.showShipmentCountOnRouteCard"
            matTooltip="{{ 'ROUTECARD.SHIPMENTCOUNT.TOOLTIP' | translate: {value: route.shipmentCount} }}">
            <div class="heading"> <i class="fa fa-arrow-right" aria-hidden="true"></i>
                <span class="caption">{{ 'ROUTECARD.SHIPMENTCOUNT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.shipmentCount | enter}}
            </div>
        </div>


        <!-- NÚMERO DE KILOGRAMS -->
        <div class="block-route-card-info-count kilos" *ngIf="route.showKilosCountOnRouteCard"
            matTooltip="{{ 'ROUTECARD.KILOSCOUNT.TOOLTIP' | translate: {value: route.kilosCount} }}">
            <div class="heading"> <i class="hardman-kg icon"></i>
                <span class="caption">{{ 'ROUTECARD.KILOSCOUNT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.kilosCount | enter}}
            </div>
        </div>


        <!-- NÚMERO DE KILOGRAMS -->
        <div class="block-route-card-info-count litres" *ngIf="route.showLitresCountOnRouteCard"
            matTooltip="{{ 'ROUTECARD.LITRESCOUNT.TOOLTIP' | translate: {value: route.litresCount} }}">
            <div class="heading"> <i class="fa fa-glass" aria-hidden="true"></i>
                <span class="caption">{{ 'ROUTECARD.LITRESCOUNT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.litresCount | enter}}
            </div>
        </div>

        <!-- QUANTITAT DE PALETS -->
        <div class="block-route-card-info-count pallet" *ngIf="route.showPalletCountOnRouteCard"
            matTooltip="{{ 'ROUTECARD.PALLETCOUNT.TOOLTIP' | translate: {value: route.palletCount} }}">
            <div class="heading"> <i class="fa fa-square icon"></i>
                <span class="caption">{{ 'ROUTECARD.PALLETCOUNT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.palletCount | enter}}
            </div>
        </div>

        <!-- NÚMERO DE PAQUETS -->
        <div class="block-route-card-info-count packet" *ngIf="route.showPacketCountOnRouteCard"
            matTooltip="{{ 'ROUTECARD.PACKETCOUNT.TOOLTIP' | translate: {value: route.packetCount} }}">
            <div class="heading"> <i class="fa fa-cubes icon"></i>
                <span class="caption">{{ 'ROUTECARD.PACKETCOUNT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.packetCount | enter}}
            </div>
        </div>

        <!-- QUANTITAT DE PRODUCTE -->
        <div class="block-route-card-info-count quantity" *ngIf="route.showQuantityProductOnRouteCard"
            matTooltip="{{ 'ROUTECARD.QUANTITYPRODUCT.TOOLTIP' | translate: {value: route.quantityProduct} }}">
            <div class="heading"> <i class="fa fa-cube icon"></i>
                <span class="caption">{{ 'ROUTECARD.QUANTITYPRODUCT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.quantityProduct.toLocaleString("es-ES") | enter }}
            </div>
        </div>

        <!-- NÚMERO DE PRODUCTES -->
        <div class="block-route-card-info-count product" *ngIf="route.showProductCountOnRouteCard"
            matTooltip="{{ 'ROUTECARD.PRODUCTCOUNT.TOOLTIP' | translate: {value: route.productCount} }}">
            <div class="heading"> <i class="fa fa-product-hunt icon"></i>
                <span class="caption">{{ 'ROUTECARD.PRODUCTCOUNT.CAPTION' | translate}}</span>
            </div>
            <div class="route-card-info-count">
                {{ route.productCount | enter}}
            </div>
        </div>
    </div>



    <div class="linea-wrapper">
        <!-- Línea base -->
        <hr class="linea" />

        <!-- Marcas dinámicas -->
        <div class="marca dinamica" *ngFor="let phase of route.phases" matTooltip="{{ phase.billingCode ? phase.billingCode : phase.alternateCode }}"
            [ngStyle]="getPosition(phase.phaseId)" (click)="openAside(phase)">
            <i class="fa icono-grande" [ngClass]="phase.isUnload ? 'fa-arrow-down' : 'fa-arrow-up'"
                aria-hidden="true"></i>
            <span class="texto-mini ellipsis"> {{ phase.billingCode ? phase.billingCode : phase.alternateCode }} </span>
            <div class="distance">{{getDistance(phase)}} km</div>
        </div>

    </div>
</ng-container>